import { useState } from "react";
import "./YouTubeEmbed.css";

/**
 * Facciata "click-to-load": mostra la thumbnail; al click monta l'iframe
 * youtube-nocookie. Vantaggi: LCP migliore (niente JS YouTube prima del click),
 * privacy/consenso (nessun cookie/script prima del click), pre-render-safe
 * (react-snap pre-renderizza la thumbnail statica). Supporta video o playlist.
 *
 * Uso:
 *   <YouTubeEmbed videoId="lE-Uu6jp1w8" title="Esame OCF -13-" onPlay={(id) => trackVideoPlay(id, "article")} />
 *   <YouTubeEmbed playlistId="PL4Ivcohv28tLVwVkyMoHpeoH2815yOBBZ" title="Playlist OCF" />
 */
export default function YouTubeEmbed({ videoId, playlistId, title = "Video", onPlay }) {
  const [active, setActive] = useState(false);

  const thumb = videoId
    ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
    : "/img/playlist-poster.jpg";

  const src = playlistId
    ? `https://www.youtube-nocookie.com/embed/videoseries?list=${playlistId}&autoplay=1&rel=0`
    : `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;

  if (!active) {
    return (
      <button
        type="button"
        className="yt-facade"
        style={{ backgroundImage: `url(${thumb})` }}
        aria-label={`Riproduci: ${title}`}
        onClick={() => {
          setActive(true);
          if (onPlay) onPlay(videoId || playlistId);
        }}
      >
        <span className="yt-play" aria-hidden="true">&#9658;</span>
      </button>
    );
  }

  return (
    <div className="yt-embed">
      <iframe
        src={src}
        title={title}
        loading="lazy"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
